/* wwp-added-modal.js v4
   - Trust strip: HORIZONTAL row (bold icons, charcoal text)
   - Free delivery progress bar
   - Upsell: 8 products, swipeable carousel with individual + Add buttons
   - Research-backed: fewer clicks to add, clear dual CTAs
*/
(function(){
  'use strict';
  if(window.wwpAddedModal)return; window.wwpAddedModal=true;

  var FREE_DELIVERY=40; /* £40 free delivery threshold */
  var CORAL='#E0948F',CHARCOAL='#2B2926',CREAM='#FFFDFB',TAN='#CA9365';
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';

  var S=document.createElement('style');
  S.textContent=[
    /* Overlay */
    '#wwp-am-overlay{position:fixed;inset:0;background:rgba(43,41,38,.55);z-index:99998;display:none;align-items:flex-end;justify-content:center;backdrop-filter:blur(2px);}',
    '@media(min-width:640px){#wwp-am-overlay{align-items:center;}}',
    /* Modal */
    '#wwp-am-modal{background:'+CREAM+';width:100%;max-width:480px;border-radius:24px 24px 0 0;padding:22px 18px 32px;position:relative;box-shadow:0 -4px 60px rgba(0,0,0,.18);max-height:90vh;overflow-y:auto;}',
    '@media(min-width:640px){#wwp-am-modal{border-radius:24px;margin:16px;}}',
    '.am-close{position:absolute;top:14px;right:14px;background:rgba(43,41,38,.07);border:none;font-size:18px;cursor:pointer;color:'+CHARCOAL+';width:32px;height:32px;border-radius:50%;display:flex;align-items:center;justify-content:center;transition:background .15s;}',
    '.am-close:hover{background:rgba(43,41,38,.13);}',
    /* Added tick */
    '.am-tick{display:flex;align-items:center;gap:8px;font-weight:700;font-size:14px;color:#1e6e3a;margin-bottom:14px;}',
    '.am-tick svg{flex-shrink:0;}',
    /* Product row */
    '.am-product{display:flex;gap:12px;align-items:flex-start;padding-bottom:14px;border-bottom:1px solid #F0EBE6;margin-bottom:14px;}',
    '.am-img{width:72px;height:72px;object-fit:cover;border-radius:12px;flex-shrink:0;background:#F5EFE6;border:1px solid #F0EBE6;}',
    '.am-info{flex:1;}',
    '.am-title{font-size:13.5px;font-weight:700;color:'+CHARCOAL+';margin:0 0 3px;line-height:1.35;}',
    '.am-price{font-size:13px;font-weight:600;color:'+CORAL+';margin:0;}',
    /* Free delivery progress bar */
    '.am-progress-wrap{margin-bottom:14px;padding:10px 12px;background:linear-gradient(135deg,#F0FBF0,#E8F5E9);border-radius:12px;border:1px solid rgba(30,110,58,.15);}',
    '.am-progress-msg{font-size:12px;font-weight:700;color:#1e6e3a;margin:0 0 6px;text-align:center;}',
    '.am-progress-msg em{font-style:normal;color:'+CORAL+';}',
    '.am-progress-bar{height:6px;background:#D4EBD4;border-radius:3px;overflow:hidden;}',
    '.am-progress-fill{height:100%;background:linear-gradient(90deg,#2a7a4b,#4CAF50);border-radius:3px;transition:width .4s ease;}',
    '.am-progress-done{font-size:12px;font-weight:700;color:#1e6e3a;text-align:center;margin:0;padding:4px 0 2px;}',
    /* HORIZONTAL trust strip */
    '.am-trust{display:flex;flex-direction:row;flex-wrap:nowrap;align-items:center;gap:14px;padding:10px 0;border-top:1px solid #F0EBE6;border-bottom:1px solid #F0EBE6;margin-bottom:14px;overflow:hidden;}',
    '.am-trust-item{display:inline-flex;align-items:center;gap:5px;font-size:12px;font-weight:700;color:'+CHARCOAL+';white-space:nowrap;flex-shrink:0;}',
    '.am-trust-item svg{flex-shrink:0;}',
    /* Checkout button (primary coral) */
    '.am-btn-checkout{display:flex;align-items:center;justify-content:center;width:100%;padding:14px;border-radius:40px;background:'+CORAL+';border:none;color:'+CHARCOAL+';font-family:inherit;font-size:14px;font-weight:700;cursor:pointer;text-decoration:none;margin-bottom:8px;transition:background .18s;}',
    '.am-btn-checkout:hover{background:#C97970;color:'+CREAM+';}',
    /* View bag (secondary outlined) */
    '.am-btn-bag{display:flex;align-items:center;justify-content:center;width:100%;padding:12px;border-radius:40px;background:transparent;border:1.5px solid '+CHARCOAL+';color:'+CHARCOAL+';font-family:inherit;font-size:13px;font-weight:700;cursor:pointer;text-decoration:none;margin-bottom:18px;transition:all .18s;}',
    '.am-btn-bag:hover{background:'+CHARCOAL+';color:'+CREAM+';}',
    /* Upsell heading */
    '.am-upsell-head{font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.07em;color:'+TAN+';margin:0 0 10px;display:flex;align-items:center;gap:6px;}',
    /* Upsell carousel */
    '.am-upsell-track{display:flex;gap:10px;overflow-x:auto;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;scrollbar-width:none;padding-bottom:4px;}',
    '.am-upsell-track::-webkit-scrollbar{display:none;}',
    /* Upsell card */
    '.am-up-card{flex:0 0 130px;scroll-snap-align:start;background:#FFFDFB;border:1px solid #F0EBE6;border-radius:14px;overflow:hidden;display:flex;flex-direction:column;}',
    '.am-up-img-wrap{width:100%;aspect-ratio:1;overflow:hidden;background:#F5EFE6;}',
    '.am-up-img{width:100%;height:100%;object-fit:cover;display:block;}',
    '.am-up-body{padding:7px 8px 8px;flex:1;display:flex;flex-direction:column;gap:3px;}',
    '.am-up-title{font-size:11px;font-weight:600;color:'+CHARCOAL+';margin:0;line-height:1.3;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;}',
    '.am-up-price{font-size:11.5px;font-weight:700;color:'+CORAL+';margin:0;}',
    '.am-up-add{margin-top:auto;display:flex;align-items:center;justify-content:center;width:100%;padding:6px 4px;border-radius:40px;background:'+CORAL+';border:none;color:'+CHARCOAL+';font-size:11px;font-weight:700;cursor:pointer;font-family:inherit;transition:background .15s;}',
    '.am-up-add:hover{background:#C97970;color:'+CREAM+';}',
    '.am-up-add.is-adding{opacity:.7;pointer-events:none;}',
    '.am-up-add.is-added{background:#2a7a4b;color:#fff;}',
    /* Suppress Dawn cart drawer when modal open */
    'body.wwp-modal-open cart-drawer{display:none!important;}',
    'body.wwp-modal-open .cart-notification{display:none!important;}',
    'body.wwp-modal-open #CartDrawer{display:none!important;}'
  ].join('');
  document.head.appendChild(S);

  var overlay=document.createElement('div');
  overlay.id='wwp-am-overlay';
  overlay.setAttribute('role','dialog');
  overlay.setAttribute('aria-modal','true');
  overlay.setAttribute('aria-label','Added to your bag');
  overlay.innerHTML=
    '<div id="wwp-am-modal">'+
    '<button class="am-close" aria-label="Close">&times;</button>'+
    '<div class="am-tick"><svg width="20" height="20" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="10" fill="#1e6e3a"/><path d="M5.5 10.5l3 3 6-6" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Added to your bag</div>'+
    '<div class="am-product"><img class="am-img" id="am-img" src="" alt="" loading="lazy"><div class="am-info"><p class="am-title" id="am-title"></p><p class="am-price" id="am-price"></p></div></div>'+
    '<div id="am-progress-wrap"></div>'+
    '<div class="am-trust">'+
      '<span class="am-trust-item"><svg viewBox="0 0 16 16" width="15" height="15" fill="'+CORAL+'"><ellipse cx="8" cy="11" rx="3.4" ry="2.6"/><circle cx="3.2" cy="7.2" r="1.5"/><circle cx="6.2" cy="4.2" r="1.5"/><circle cx="9.8" cy="4.2" r="1.5"/><circle cx="12.8" cy="7.2" r="1.5"/></svg>We Wuv Standard</span>'+
      '<span class="am-trust-item"><svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="'+TAN+'" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="5" width="10" height="7" rx="1"/><path d="M11 7h3l2 2v3h-5z"/><circle cx="3.5" cy="13" r="1.2"/><circle cx="11.5" cy="13" r="1.2"/></svg>Tracked delivery</span>'+
      '<span class="am-trust-item"><svg viewBox="0 0 16 16" width="15" height="15" fill="none"><path d="M8 14C8 14 2 10.5 2 6.5C2 4.6 3.6 3.2 5.5 3.2C6.5 3.2 7.4 3.8 8 4.5C8.6 3.8 9.5 3.2 10.5 3.2C12.4 3.2 14 4.6 14 6.5C14 10.5 8 14 8 14Z" fill="'+CORAL+'" fill-opacity="0.18" stroke="'+CORAL+'" stroke-width="1.1"/><path d="M6.2 7L7.2 8L9.8 5.5" stroke="'+TAN+'" stroke-width="1.1" stroke-linecap="round"/></svg>30-day returns</span>'+
    '</div>'+
    '<a href="/checkout" class="am-btn-checkout">Checkout now</a>'+
    '<a href="/cart" class="am-btn-bag">View bag</a>'+
    '<p class="am-upsell-head"><svg viewBox="0 0 16 16" width="13" height="13" fill="none" stroke="'+TAN+'" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M2 8h12M8 2l6 6-6 6"/></svg>Pairs well with this</p>'+
    '<div class="am-upsell-track" id="am-upsell"></div>'+
    '</div>';
  document.body.appendChild(overlay);

  var imgEl=document.getElementById('am-img');
  var titleEl=document.getElementById('am-title');
  var priceEl=document.getElementById('am-price');
  var progressWrap=document.getElementById('am-progress-wrap');
  var upsellTrack=document.getElementById('am-upsell');

  function updateProgress(cartTotal){
    var total=cartTotal/100;
    var remaining=FREE_DELIVERY-total;
    if(remaining<=0){
      progressWrap.innerHTML='<div class="am-progress-wrap"><p class="am-progress-done">&#127881; You have FREE UK delivery on this order!</p></div>';
    } else {
      var pct=Math.min((total/FREE_DELIVERY)*100,100);
      progressWrap.innerHTML='<div class="am-progress-wrap"><p class="am-progress-msg">Spend <em>\u00a3'+remaining.toFixed(2)+' more</em> for FREE UK delivery</p><div class="am-progress-bar"><div class="am-progress-fill" style="width:'+pct+'%"></div></div></div>';
    }
  }

  function openModal(data){
    titleEl.textContent=data.title||'';
    priceEl.textContent=data.price?'\u00a3'+parseFloat(data.price).toFixed(2):'';
    var img=data.image||'';
    if(img&&img.indexOf('//')==0)img='https:'+img;
    if(img&&img.indexOf('http')!==0)img='';
    imgEl.src=img; imgEl.alt=data.title||'';
    overlay.style.display='flex';
    document.body.classList.add('wwp-modal-open');
    loadUpsell(data.productId);
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
      updateProgress(c.total_price);
      document.querySelectorAll('[data-cart-count],[data-cart-item-count],.cart-count-bubble span,.cart-count-bubble').forEach(function(el){el.textContent=c.item_count;});
    }).catch(function(){progressWrap.innerHTML='';});
  }

  function closeModal(){
    overlay.style.display='none';
    document.body.classList.remove('wwp-modal-open');
  }

  overlay.addEventListener('click',function(e){if(e.target===overlay)closeModal();});
  overlay.querySelector('.am-close').addEventListener('click',closeModal);
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeModal();});

  function loadUpsell(productId){
    upsellTrack.innerHTML='';
    var url=productId
      ?root+'recommendations/products.json?product_id='+productId+'&limit=12'
      :root+'collections/popular-products/products.json?limit=12';
    fetch(url).then(function(r){return r.json();}).then(function(d){
      var products=(d.products||d.recommended_products||[]).filter(function(p){
        return p.images&&p.images.length>0&&!(p.tags&&p.tags.join(',').indexOf('Bundle')>-1);
      }).slice(0,8);
      if(!products.length)fetchFallback();
      else renderUpsell(products);
    }).catch(fetchFallback);
  }

  function fetchFallback(){
    fetch(root+'collections/popular-products/products.json?limit=15').then(function(r){return r.json();}).then(function(d){
      var products=(d.products||[]).filter(function(p){
        return p.images&&p.images.length>0&&!(p.tags&&p.tags.join(',').indexOf('Bundle')>-1);
      }).slice(0,8);
      renderUpsell(products);
    }).catch(function(){});
  }

  function renderUpsell(products){
    upsellTrack.innerHTML=products.map(function(p,i){
      var imgData=p.images[0];
      var src=typeof imgData==='string'?imgData:(imgData&&(imgData.src||imgData.url||''));
      if(!src)return '';
      if(src.indexOf('//')==0)src='https:'+src;
      src=src+(src.indexOf('?')>-1?'&':'?')+'width=280';
      var varId=p.variants&&p.variants[0]?p.variants[0].id:'';
      var price=p.variants&&p.variants[0]?'\u00a3'+parseFloat(p.variants[0].price).toFixed(2):'';
      var fromText=(p.variants&&p.variants.length>1)?'From ':'';
      return '<div class="am-up-card">'+
        '<a href="'+root+'products/'+p.handle+'" class="am-up-img-wrap"><img class="am-up-img" src="'+src+'" alt="'+(p.title||'').replace(/"/g,'')+'" loading="lazy"></a>'+
        '<div class="am-up-body">'+
        '<p class="am-up-title">'+(p.title||'')+'</p>'+
        (price?'<p class="am-up-price">'+fromText+price+'</p>':'')+
        (varId?'<button type="button" class="am-up-add" data-variant-id="'+varId+'" data-product-handle="'+p.handle+'">+ Add</button>':'')+
        '</div></div>';
    }).join('');

    /* Attach add buttons */
    upsellTrack.querySelectorAll('.am-up-add').forEach(function(btn){
      btn.addEventListener('click',function(){
        var vid=btn.getAttribute('data-variant-id');
        if(!vid||btn.classList.contains('is-adding'))return;
        btn.classList.add('is-adding');
        btn.textContent='Adding...';
        fetch('/cart/add.js',{
          method:'POST',
          headers:{'Content-Type':'application/json'},
          body:JSON.stringify({id:vid,quantity:1})
        }).then(function(r){return r.json();}).then(function(){
          btn.classList.remove('is-adding');
          btn.classList.add('is-added');
          btn.textContent='\u2713 Added';
          /* Update cart count and progress */
          fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
            updateProgress(c.total_price);
            document.querySelectorAll('[data-cart-count],[data-cart-item-count],.cart-count-bubble span,.cart-count-bubble').forEach(function(el){el.textContent=c.item_count;});
          });
        }).catch(function(){
          btn.classList.remove('is-adding');
          btn.textContent='+ Add';
        });
      });
    });
  }

  /* Intercept add-to-bag */
  function interceptForm(form){
    if(form.dataset.wwpBound)return;
    form.dataset.wwpBound='1';
    form.addEventListener('submit',function(e){
      if(!form.action||!form.action.includes('/cart/add'))return;
      e.preventDefault();
      fetch('/cart/add.js',{method:'POST',body:new FormData(form)}).then(function(r){return r.json();}).then(function(item){
        var img=item.featured_image?(item.featured_image.url||item.featured_image):(item.image||'');
        openModal({title:item.product_title||item.title,price:item.price?(item.price/100).toFixed(2):'',image:img,productId:item.product_id});
      }).catch(function(){form.submit();});
    });
  }

  document.querySelectorAll('form[action*="/cart/add"]').forEach(interceptForm);
  document.addEventListener('wwpItemAdded',function(e){if(e.detail)openModal(e.detail);});
  new MutationObserver(function(){
    document.querySelectorAll('form[action*="/cart/add"]:not([data-wwp-bound])').forEach(interceptForm);
  }).observe(document.body,{childList:true,subtree:true});

})();
